import clsx from 'clsx';
import Body from './Body';
import Store from '../Store';
import * as React from 'react';
import { observer } from 'mobx-react';
import { activeTabPageClassName } from '../Types';

export interface Props {
  store: Store;
}

const Programs: React.FC<Props> = ({ store }) => {
  return (
    <div
      id="programs"
      className={clsx(
        activeTabPageClassName(store.state, 'programs'),
        'max-h-[57vh] overflow-auto px-11',
      )}
      data-intercom-target="programs-tab-page"
    >
      {store.resource.payload.experiences.map((experience, i) => (
        <Body
          resource={experience}
          key={experience.payload.id}
          intercomTarget={`program-item-${i + 1}`}
        />
      ))}
    </div>
  );
};

export default observer(Programs);
